// removed by extract-text-webpack-plugin
module.exports = {"section":"src-components-GroupsSection__section--3QgU_","top":"src-components-GroupsSection__top--7tkpj","groups":"src-components-GroupsSection__groups--2_LQ4","list":"src-components-GroupsSection__list--2NYRp","group":"src-components-GroupsSection__group--3qKFU","topRight":"src-components-GroupsSection__topRight--2GT6h","statusDot":"src-components-GroupsSection__statusDot--2Ik4s","statusDotGreen":"src-components-GroupsSection__statusDotGreen--3IY1C","changeGroupsBtn":"src-components-GroupsSection__changeGroupsBtn--2jBpJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GroupsSection.scss
// module id = 82
// module chunks = 0